import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { UmsService } from '../ums.service';
declare var $;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  // pieChartData: number[];
  // pieChartLabels:String[];
  // pieChartType:String;
  FemaleCount: any;
  StudentCount: any = [];
  StockCount: any = [];


  public pieChartLabels: string[] = ['Male', 'Female'];
  public pieChartData: number[] = [40, 20];
  public pieChartType: string = 'pie';

  public StockpieChartLabels: string[] = ['Pen', 'Table'];
  public StockpieChartData: number[] = [10, 20];
  public StockpieChartType: string = 'pie';

  constructor(private router: Router,public formBuilder: FormBuilder,
    public UmsApi: UmsService) {
      
     }
  ngOnInit() {
   this.GetAllCount();
 
//     window.onpopstate = function() {
//       setTimeout(() => {
//   $("#HeaderId").hide();
//   $("#SidebarId").hide();
//   var element = document.getElementById("ContentWp");
//   element.classList.remove("content-wrapper");
// }, 100);
//       count=0;
//     // alert(count)
//       window.history.pushState(null, "", window.location.href);

// }

// var count=0;

 }

  
  

 


  Logout() {
    localStorage.LS_RoleId = '';
    localStorage.LS_SchoolId = '';
    localStorage.LS_UserId = '';

    this.router.navigate(['/UserLogin']);

    setTimeout(() => {
      $("#HeaderId").hide();
      $("#SidebarId").hide();
      var element = document.getElementById("ContentWp");
      element.classList.remove("content-wrapper");
    }, 100);

  }



  
 HandleBackFunctionality()  
  {  
    alert("HH")
        if(window.event) //Internet Explorer  
       {  
            this.Logout();
        }  
        else //Other browsers for example Chrome  
        {  
          alert("ch")
           this.Logout();
        }  
  } 



  GetAllCount() {

    var schoolId = localStorage.LS_SchoolId;
    this.UmsApi.GetAllCount(schoolId).subscribe(response => {
      
      if (response.result) {
        this.StudentCount = response.result.studentPieChart;
        this.pieChartData = [this.StudentCount[0].male, this.StudentCount[0].female];

        this.StockCount = response.result.stockPieChart;
        this.StockpieChartLabels =[]
        this.StockpieChartData =[]
      
        for (let i = 0; i < this.StockCount.length; i++) {
          this.StockpieChartLabels.push(this.StockCount[i].itemName);
          this.StockpieChartData.push(this.StockCount[i].availableQty);
        }

      }
      else {
        this.StudentCount = [];
        this.StockCount=[];
      }
    }, error => {
      console.log(error);
    });
  }

}
